// hook for custom event tracking
import { useCallback } from 'react'
import { trackEvent } from './analyticsService'

export function useTracking(category) {
	const track = useCallback((eventName, params = {}) => {
		trackEvent(eventName, { component: category, ...params })
	}, [category])
	return { track }
}